import { render } from "./checkBox.vue?vue&type=template&id=de98a9b0"
import script from "./checkBox.vue?vue&type=script&lang=js"
export * from "./checkBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__